import { QuickAccessWidget } from '@hefe/models';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

const QUICK_ACCESS_WIDGETS_FEATURE_KEY = 'quickAccessWidgets';

interface QuickAccessWidgetsState {
  activeWidgets: string[];
}

const initialQuickAccessWidgetsState: QuickAccessWidgetsState = {
  activeWidgets: [],
};

const _quickAccessWidgetsSlice = createSlice({
  name: QUICK_ACCESS_WIDGETS_FEATURE_KEY,
  initialState: initialQuickAccessWidgetsState,
  reducers: {
    add: (state, action: PayloadAction<QuickAccessWidget>) => {
      state.activeWidgets.push(action.payload.id);
    },
    remove: (state, action: PayloadAction<QuickAccessWidget>) => {
      state.activeWidgets = state.activeWidgets.filter(
        (widgetId) => widgetId !== action.payload.id
      );
    },
    setAll: (state, action: PayloadAction<string[]>) => {
      state.activeWidgets = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = _quickAccessWidgetsSlice.reducer;
const actions = _quickAccessWidgetsSlice.actions;

const getQuickAccessWidgetsState = (rootState: any): QuickAccessWidgetsState =>
  rootState[QUICK_ACCESS_WIDGETS_FEATURE_KEY];

const quickAccessWidgetsState = createSelector(
  getQuickAccessWidgetsState,
  (state) => state
);

const activeWidgetsSelector = createSelector(
  getQuickAccessWidgetsState,
  (state) => state.activeWidgets
);

export { actions, reducer, activeWidgetsSelector };
